module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-solid-900.6c207a7b.eot";